import { getWebStorage } from "./storage";

const LAST_EMAIL_KEY = "lastEmail";

/**
 * Read and written synchronously (it prefills the sign-in form during render),
 * so this goes straight to web storage rather than through the async `Storage`
 * class. Both calls no-op when web storage is unavailable — remembering the last
 * email is a convenience, never a requirement for signing in.
 */
export const saveLastEmail = (email: string) => {
  getWebStorage()?.setItem(LAST_EMAIL_KEY, email);
};

export const getLastEmail = () => {
  return getWebStorage()?.getItem(LAST_EMAIL_KEY) ?? null;
};
